export default __webpack_public_path__ + "static/media/soc-img.0fc42579.jpg";